// src/features/privateAlbum/components/AlbumStats.jsx

import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Paper,
  Stack,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
} from "@mui/material";
import {
  Visibility as ViewIcon,
  Download as DownloadIcon,
  Comment as CommentIcon,
  Person as PersonIcon,
  Key as KeyIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";

const AlbumStats = ({ stats }) => {
  if (!stats) return null;

  const statCards = [
    {
      label: "Total Views",
      value: stats.totalViews || 0,
      icon: <ViewIcon />,
      color: "#2196f3",
      bgColor: "#e3f2fd",
    },
    {
      label: "Total Downloads",
      value: stats.totalDownloads || 0,
      icon: <DownloadIcon />,
      color: "#4caf50",
      bgColor: "#e8f5e9",
    },
    {
      label: "Total Comments",
      value: stats.totalComments || 0,
      icon: <CommentIcon />,
      color: "#9c27b0",
      bgColor: "#f3e5f5",
    },
    {
      label: "Unique Viewers",
      value: stats.uniqueViewers || 0,
      icon: <PersonIcon />,
      color: "#ff9800",
      bgColor: "#fff3e0",
    },
    {
      label: "Access Count",
      value: stats.totalAccess || 0,
      icon: <KeyIcon />,
      color: "#f44336",
      bgColor: "#ffebee",
    },
    {
      label: "Active Access",
      value: stats.activeAccess || 0,
      icon: <CheckCircleIcon />,
      color: "#4caf50",
      bgColor: "#e8f5e9",
    },
  ];

  return (
    <Box sx={{ mt: 4 }}>
      {/* Stats Cards */}
      <Grid container spacing={2}>
        {statCards.map((stat) => (
          <Grid item xs={6} sm={4} md={2} key={stat.label}>
            <Card sx={{ bgcolor: stat.bgColor }}>
              <CardContent sx={{ textAlign: "center", py: 2 }}>
                <Avatar
                  sx={{
                    bgcolor: stat.color,
                    mx: "auto",
                    mb: 1,
                    width: 40,
                    height: 40,
                  }}
                >
                  {stat.icon}
                </Avatar>
                <Typography variant="h5" fontWeight="bold">
                  {stat.value}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {stat.label}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Most Viewed Photos */}
      {stats.mostViewedPhotos && stats.mostViewedPhotos.length > 0 && (
        <Paper sx={{ p: 2, mt: 3 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Most Viewed Photos
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <List dense>
            {stats.mostViewedPhotos.map((item, index) => (
              <ListItem
                key={item.photoId}
                divider={index < stats.mostViewedPhotos.length - 1}
              >
                <ListItemAvatar>
                  <Avatar
                    variant="rounded"
                    src={item.photo?.thumbnailUrl}
                    sx={{ width: 48, height: 48 }}
                  >
                    {!item.photo?.thumbnailUrl && <ViewIcon />}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    item.photo?.caption || item.photo?.fileName || "Unknown"
                  }
                  secondary={`#${index + 1} in views`}
                />
                <Typography variant="body2" fontWeight="medium">
                  {item.views} views
                </Typography>
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );
};

export default AlbumStats;
